import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { ExclamationMarkIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  DeactivationReasonEnum,
  deactivationReasonEnumMapping
} from '../../../../lib/types/enums/staff/deactivation-reason.enum'
import { DeactivateStaffInput } from '../../../../lib/types/models/staff/admin-staff-input'
import { BaseFormProps } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedEnumOption } from '../../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../../lib/utils/validations/enum-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledSelectInput from '../../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../../elements/validation-buttons'

type Props = BaseFormProps<DeactivateStaffInput, true> & {
  className?: string
}

const formSchema: ZodType<DeactivateStaffInput> = z.object({
  deactivationReason: createEnumSchema({
    fieldName: 'motif de désactivation',
    enumType: DeactivationReasonEnum
  })
})

const StaffDeactivateForm = ({ className, defaultValues, ...validationButtonProps }: Props) => {
  const form = useForm<DeactivateStaffInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-3', className)}>
          <FormField
            control={form.control}
            name={'deactivationReason'}
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput
                    {...field}
                    searchable
                    label={'Motif de la désactivation'}
                    options={Object.values(DeactivationReasonEnum).map((status) => ({
                      label: deactivationReasonEnumMapping[status],
                      value: status
                    }))}
                    selectedOption={getSelectedEnumOption(
                      field.value,
                      deactivationReasonEnumMapping
                    )}
                  />
                </FormControl>
              </FormItem>
            )}
          />
          <div className="flex gap-1 items-center w-full bg-red-light p-2 rounded">
            <ExclamationMarkIcon filled={false} color={tailwindColors.red.DEFAULT} />
            <Typography variant="small-semibold" color={tailwindColors.red.DEFAULT}>
              La désactivation arrête l'envoi de notifications et empêche l'attribution à un séjour
            </Typography>
          </div>
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default StaffDeactivateForm
